module.exports = __webpack_public_path__ + "img/profileArrow.31e7f22a.svg";